<template>
    <div class="section_header">
        <router-link
            to="/"
            class="characteristics_title"
        >
            <img
                src="@/assets/logo_white.png"
                class="logo_header"
            />
        </router-link>
        <div class="href_HeaderNavFirst">
            <router-link
                to="/about"
                class="text_HeaderNavFirst"
            >
                Клиентам
            </router-link>
            <router-link
                to="/vacancies"
                class="text_HeaderNavFirst"
            >
                Соискателям
            </router-link>
            <router-link
                to="/employees"
                class="text_HeaderNavFirst"
            >
                Сотрудникам
            </router-link>
            <button
                class="text_HeaderNavFirst"
                :class="{ active: showContacts }"
                @click="showContacts = !showContacts"
            >
                Контакты
            </button>
            <div
                class="container_contacts_header"
                :class="{ visible: showContacts }"
            >
                <div
                    class="box_contacts_header"
                    @click="copyPhone"
                >
                    <p class="text_contacts_header">Для клиентов</p>
                    <div class="contacts_header">
                        <a class="text_contacts_header">
                            +7 913 660 39 97
                        </a>
                        <div class="copying_clients"></div>
                        <div class="copying_text">Скопировано</div>
                    </div>
                </div>
                <div
                    class="box_contacts_header"
                    @click="copyPhone"
                >
                    <p class="text_contacts_header">Для соискателей</p>
                    <div class="contacts_header">
                        <a class="text_contacts_header">
                            +7 950 953 92 92
                        </a>
                        <div class="copying_clients"></div>
                        <div class="copying_text">Скопировано</div>
                    </div>
                </div>
            </div>
        </div>
        <ModalHeader />
    </div>

</template>

<script>
import ModalHeader from '@/shared/components/modal-header/ModalHeader.vue';
export default {
    components: { ModalHeader },
    props: {
        title: String,
    },
    data () {
        return {
            showModal: false,
            showContacts: false,
        };
    },
    methods: {
        toggleModal () {
            this.showModal = !this.showModal;
            this.toggleBurgerClasses();
            document.body.classList.toggle('no-scroll');
        },
        closeModal () {
            this.showModal = false;
            this.toggleBurgerClasses();
            document.body.classList.remove('no-scroll');
        },
        toggleBurgerClasses () {
            const burgerButton = document.querySelector('.burger_button');
            const burgerLines = document.querySelectorAll('.burger_line');

            if (this.showModal) {
                burgerButton.classList.add('active');
                burgerLines.forEach((line) => line.classList.add('active'));
            } else {
                burgerButton.classList.remove('active');
                burgerLines.forEach((line) => line.classList.remove('active'));
            }
        },
        copyPhone (event) {
            const contactsHeader = event.currentTarget.querySelector('.contacts_header');

            if (!contactsHeader) return;

            const phoneElement = contactsHeader.querySelector('a');
            const textEl = contactsHeader.querySelector('.copying_text');

            const phone = phoneElement?.innerText?.trim();

            if (phone && textEl) {
                navigator.clipboard.writeText(phone).then(() => {
                    textEl.style.display = 'block';
                    setTimeout(() => {
                        textEl.style.display = 'none';
                    }, 3000);
                });
            }
        },

    },
};
</script>

<style scoped>
.logo_header {
    width: 3.55rem;
    height: 2.55rem;
}

.section_header {
    justify-content: flex-start;
    padding: 2rem 2rem 2rem 3rem;
    gap: 1.7rem;
    backdrop-filter: blur(1rem);
    align-items: center;
    background: rgba(25, 25, 25, 0.7);
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
}
.href_HeaderNavFirst {
    position: relative;
    display: flex;
    gap: 3rem;
    align-items: center;
}
.text_HeaderNavFirst {
    color: rgb(245, 245, 245);
    font-family: Rostov;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1rem;
    transition: 0.2s ease;
}
.text_HeaderNavFirst:hover {
    color: rgb(220, 102, 64);
    transition: 0.2s ease;
}
.text_contacts_header{
    color: rgb(245, 245, 245);
font-family: Montserrat_SemiBold;
font-size: 0.7rem;
font-weight: 700;
line-height: 0.7rem;
}
.copying_clients{
    width: 0.45rem;
height: 0.55rem;
    background-image: url(/src/assets/elements/copying.png);
    background-position: 50%;
    background-repeat: no-repeat;
    transition: 0.2s ease;
    background-size: contain;
}
.contacts_header{
    display: flex;
    gap: 0.3rem;
    align-items: center;
}
.box_contacts_header{
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    cursor: pointer;
    position: relative;
    cursor: pointer;
}
.box_contacts_header:hover .copying_clients{
    background-image: url(/src/assets/elements/copying_hover.png);
    background-repeat: no-repeat;
    transition: 0.2s ease;
    background-size: contain;
}

.copying_text {
    position: absolute;
   bottom: -1.5rem;
    right: 0;
    font-family: Montserrat_SemiBold;
font-size: 0.7rem;
font-weight: 700;
line-height: 0.7rem;
    color: #fff;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
    font-size: 0.6rem;
    white-space: nowrap;
    display: none;
    z-index: 100;
    border: 0.1rem solid rgb(220, 102, 64);
    z-index: 1;
}
.container_contacts_header {
    position: absolute;
    right: -14.5rem;
    opacity: 0;
    pointer-events: none;
    transition: 0.2s ease;
    display: flex;
    gap: 1.5rem;
}

.container_contacts_header.visible {
    opacity: 1;
    pointer-events: auto;
    right: -17.5rem;
    transition: 0.2s ease;
}

.text_HeaderNavFirst.active {
    color: rgb(220, 102, 64); /* как hover-цвет */
}

@media (max-width: 768px) {
    .href_HeaderNavFirst{
        display: none;
    }
    .section_header{
        background: none;
        padding: 2.5rem 1.8rem 2.5rem 1.8rem;
        backdrop-filter: blur(0rem);
    }

    .section_header{
        justify-content: space-between;
    }

}
</style>
